import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider.jsx'
import ForbiddenPage from './ForbiddenPage.jsx'

export default function ProtectedRoute({ allow }) {
  const { isAuthenticated, authReady, user } = useAuth()
  const location = useLocation()

  if (!authReady) {
    return <div className="app-loading">불러오는 중...</div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (typeof allow === 'function' && !allow(user)) {
    return <ForbiddenPage />
  }

  return <Outlet />
}
